import i18n from "@/i18n";
import { displayName } from "./user";
import type { Lesson } from "./types";

/**
 * Display label for a lesson's instructor.
 *
 * Prefers the `instructor` object the API embeds on a lesson (issue #224
 * follow-up) so the real teacher name is shown — falling back to the
 * `Instructor #id` placeholder when the association wasn't embedded
 * (older payloads / runbook internals).
 */
export function instructorLabel(
  lesson: Pick<Lesson, "instructor" | "instructor_id">,
): string {
  if (lesson.instructor) return displayName(lesson.instructor);
  return i18n.t("common.instructor", { id: lesson.instructor_id });
}
